module.exports = __webpack_public_path__ + "./RaymondPhoto_9641e9112567f3b8699551b50683e718.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2020/RaymondPhoto.png
// module id = 505
// module chunks = 0